export enum AlertTypesEnum {
    Success = 'accent',
    Error = 'danger',
    Info = 'primary',
    Warning = 'warning'
}
